module.exports = __webpack_public_path__ + "static/media/BadgeproudPioneer.a42daa80.svg";